"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleFilterRange = void 0;
const react_1 = __importDefault(require("react"));
const ExampleFilterRange = (props) => {
    return (react_1.default.createElement("div", { className: "rs__filter" },
        react_1.default.createElement("h3", { className: "rs__filter__name" }, props.filter.name),
        react_1.default.createElement("ul", { className: "rs__filter__list" }, props.filterRangeProps.options.map((option) => (react_1.default.createElement("li", { key: option.key, className: "rs__filter__list-item" },
            react_1.default.createElement("label", { className: "rs__filter__list-item-label" },
                react_1.default.createElement("input", { className: "rs__filter__list-item-input", value: option.key, type: "multi" === props.filterRangeProps.filter.displayType
                        ? "checkbox"
                        : "radio", checked: option.checked, onChange: (event) => props.filterRangeProps.handleChange(event.target.value) }),
                react_1.default.createElement("span", { className: "rs__filter__list-item-key" }, option.label))))))));
};
exports.ExampleFilterRange = ExampleFilterRange;
//# sourceMappingURL=ExampleFilterRange.js.map